<div class="component-viewer">
    <mat-card>
        <mat-card-header>
            <mat-card-title>My Account</mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <div class="row mt-2 mb-3">
                <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
            </div>
            <mat-tab-group dynamicHeight>
                <mat-tab>
                    <ng-template mat-tab-label>
                        <mat-icon class="example-tab-icon">account_circle</mat-icon>
                        <span>User Information</span>
                    </ng-template>
                    <form class="container-fluid py-3" [formGroup]="userForm" (ngSubmit)="onUserInfoSubmit()">
                        <div class="row">
                            <div class="col-md-6">
                                <mat-form-field class="w-100">
                                    <mat-label>First Name</mat-label>
                                    <input matInput formControlName="firstName" required>
                                    <mat-error *ngIf="userForm.get('firstName').errors?.required">
                                        First name is required
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            <div class="col-md-6">
                                <mat-form-field class="w-100">
                                    <mat-label>Last Name</mat-label>
                                    <input matInput formControlName="lastName" required>
                                    <mat-error *ngIf="userForm.get('lastName').errors?.required">
                                        Last name is required
                                    </mat-error>
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <mat-form-field class="w-100">
                                    <mat-label>Email</mat-label>
                                    <input matInput formControlName="email" required type="email" readonly>
                                    <mat-error *ngIf="userForm.get('email').errors?.required">
                                        Email is required
                                    </mat-error>
                                    <mat-error *ngIf="userForm.get('email').errors?.email">
                                        Please enter a valid email
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            <div class="col-md-6">
                                <mat-form-field class="w-100">
                                    <mat-label>Phone Number</mat-label>
                                    <input matInput formControlName="phoneNumber" required>
                                    <mat-error *ngIf="userForm.get('phoneNumber').errors?.required">
                                        Phone number is required
                                    </mat-error>
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <mat-form-field class="w-100">
                                    <mat-label>GolfTech Type</mat-label>
                                    <mat-select formControlName="golfTechType" required>
                                        <mat-option [value]="GolfTechType.Organizer">Organizer</mat-option>
                                        <mat-option [value]="GolfTechType.Golfer">Golfer</mat-option>
                                        <mat-option [value]="GolfTechType.Course">Course</mat-option>
                                        <mat-option [value]="GolfTechType.CheckIn">Check-In</mat-option>
                                        <mat-option [value]="GolfTechType.GlobalAdmin">Global Admin</mat-option>
                                    </mat-select>
                                    <mat-error *ngIf="userForm.get('golfTechType').errors?.required">
                                        GolfTech type is required
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            <div class="col-md-6">
                                <mat-form-field class="w-100">
                                    <mat-label>Venmo Username</mat-label>
                                    <input matInput formControlName="venmoUsername">
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="row mb-3 align-items-center">
                            <div class="col-md-6">
                                <input type="file" class="file-input" accept="image/*"
                                    (change)="onVenmoQrSelected($event)" #venmoQrUpload />
                                <button type="button" mat-raised-button (click)="venmoQrUpload.click()">
                                    <mat-icon>attach_file</mat-icon>
                                    Venmo QR Code
                                </button>
                                <span class="ms-2 text-muted small">{{ venmoQrFileName || 'No file uploaded yet.' }}</span>
                            </div>
                        </div>
                        <div class="row mt-2">
                            <div class="col text-end">
                                <button mat-raised-button color="primary" type="submit"
                                    [disabled]="!userForm.valid || isLoading">
                                    Save User Information
                                </button>
                            </div>
                        </div>
                    </form>
                </mat-tab>
                <mat-tab>
                    <ng-template mat-tab-label>
                        <mat-icon class="example-tab-icon">business</mat-icon>
                        <span>Organization</span>
                    </ng-template>

                    <div class="container-fluid">
                        <div class="row mt-4 mb-4">
                            <div class="col-12">
                                <mat-card appearance="outlined">
                                    <mat-card-header>
                                        <mat-card-title class="d-flex align-items-center flex-wrap gap-2">
                                            <mat-icon color="primary">account_balance</mat-icon>
                                            Stripe Account
                                            <ng-container
                                                *ngIf="sessionService.getUser().stripeAccountId !== null && (stripeAccount?.requirements?.past_due?.length ?? 0) === 0">
                                                <a mat-raised-button color="primary" [href]="stripeLoginLink?.url"
                                                    target="_blank">
                                                    <mat-icon>login</mat-icon>
                                                    Login to Stripe
                                                </a>
                                            </ng-container>
                                            <ng-container *ngIf="sessionService.getUser().stripeAccountId == null">
                                                <button mat-raised-button color="primary" type="button"
                                                    (click)="onboard()">
                                                    <mat-icon>handshake</mat-icon>
                                                    Onboard
                                                </button>
                                            </ng-container>
                                            <ng-container *ngIf="(stripeAccount?.requirements?.past_due?.length ?? 0) > 0">
                                                <button mat-raised-button class="primary" type="button"
                                                    (click)="getAccountLink()">
                                                    <mat-icon>auto_fix_high</mat-icon>
                                                    Fix Past Due Items
                                                </button>
                                            </ng-container>
                                        </mat-card-title>
                                    </mat-card-header>
                                    <mat-card-content class="pt-3">
                                        <ng-container
                                            *ngIf="sessionService.getUser().stripeAccountId !== null && (stripeAccount?.requirements?.past_due?.length ?? 0) === 0">
                                            <div class="d-flex align-items-center justify-content-between">
                                                <div class="d-flex align-items-center">
                                                    <mat-icon class="me-2 text-success">check_circle</mat-icon>
                                                    <div>
                                                        <div class="h6 mb-0 text-success">Account Activated</div>
                                                        <div class="text-muted small">Your Stripe account is active and
                                                            ready to accept payments</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </ng-container>
                                        <ng-container
                                            *ngIf="(stripeAccount?.requirements?.past_due?.length ?? 0) > 0 && !isPreparingOnboarding">
                                            <div class="d-flex align-items-start">
                                                <mat-icon class="me-2 secondary">warning</mat-icon>
                                                <div>
                                                    <div class="h6 mb-1 text-warning">Account Pending</div>
                                                    <p class="text-muted mb-0">Your Stripe Account is pending. Please
                                                        complete the onboarding to continue accepting payments.</p>
                                                </div>
                                            </div>
                                        </ng-container>
                                        <ng-container *ngIf="sessionService.getUser().stripeAccountId === null">
                                            <div class="d-flex align-items-start">
                                                <mat-icon class="me-2 warning">not_interested</mat-icon>
                                                <div>
                                                    <div class="h6 mb-1 text-danger">Account Not Activated</div>
                                                    <p class="text-muted mb-0">Please click the onboard button to
                                                        complete the Stripe Onboarding process.</p>
                                                </div>
                                            </div>
                                        </ng-container>
                                        <ng-container *ngIf="isPreparingOnboarding">
                                            <div class="d-flex align-items-start justify-content-center py-4">
                                                <mat-progress-spinner mode="indeterminate" diameter="60"
                                                    class="me-3"></mat-progress-spinner>
                                                <div>
                                                    <div class="h6 mb-0">Preparing Onboarding...</div>
                                                    <p class="text-muted small mb-0">Please wait while we set up your
                                                        account verification</p>
                                                </div>
                                            </div>
                                        </ng-container>
                                        <div id="connect-container-outing"></div>
                                    </mat-card-content>
                                </mat-card>
                            </div>
                        </div>

                        <form [formGroup]="organizationForm" (ngSubmit)="onOrganizationSubmit()">
                            <div class="row align-items-baseline">
                                <div class="col-md-6">
                                    <mat-form-field class="w-100">
                                        <mat-label>Organization Name</mat-label>
                                        <input matInput formControlName="organizationName" required>
                                        <mat-error *ngIf="organizationForm.get('organizationName').errors?.required">
                                            Organization name is required
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="row align-items-center">
                                <div class="col-md-6">
                                    <mat-form-field class="w-100">
                                        <mat-label>API Key</mat-label>
                                        <input matInput formControlName="widgetApiKey" readonly>
                                        <mat-error *ngIf="organizationForm.get('widgetApiKey').errors?.server">
                                            Unable to regenerate API Key
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                                <div class="col-auto mb-4">
                                    <button mat-fab type="button" (click)="regenerateApiKey()"
                                        matTooltip="Regenerate API key">
                                        <mat-icon>refresh</mat-icon>
                                    </button>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <mat-form-field class="w-100">
                                        <mat-label>Timezone</mat-label>
                                        <mat-select formControlName="timeZone" required>
                                            <mat-option *ngFor="let timezone of usTimezones" [value]="timezone.value">
                                                {{ timezone.label }}
                                            </mat-option>
                                        </mat-select>
                                        <mat-error *ngIf="organizationForm.get('timeZone').errors?.required">
                                            Timezone is required
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="row align-items-baseline">
                                <div class="col-md-6">
                                    <mat-form-field class="w-100 mt-2">
                                        <mat-label>Credit Card Fee {{ isFeePercentage ? '(%)' : '($)' }}</mat-label>
                                        <input matInput type="number" formControlName="creditCardFee" [min]="0"
                                            [max]="isFeePercentage ? 100 : null" required>
                                        <span matSuffix *ngIf="isFeePercentage">%</span>
                                        <span matPrefix *ngIf="!isFeePercentage">$</span>
                                        <mat-error *ngIf="organizationForm.get('creditCardFee').errors?.required">
                                            Credit card fee is required
                                        </mat-error>
                                        <mat-error *ngIf="organizationForm.get('creditCardFee').errors?.min">
                                            Fee cannot be negative
                                        </mat-error>
                                        <mat-error *ngIf="organizationForm.get('creditCardFee').errors?.max">
                                            Fee cannot exceed 100%
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                                <div class="col-md-6">
                                    <mat-button-toggle-group formControlName="creditCardFeeType"
                                        (change)="onFeeTypeChange()">
                                        <mat-button-toggle [value]="CreditCardFeeType.Percentage">Percentage
                                        </mat-button-toggle>
                                        <mat-button-toggle [value]="CreditCardFeeType.Fixed">Fixed Amount
                                        </mat-button-toggle>
                                    </mat-button-toggle-group>
                                </div>
                            </div>
                            <div class="row mt-3">
                                <div class="col text-end">
                                    <button mat-raised-button color="primary" type="submit"
                                        [disabled]="!organizationForm.valid || isLoading">
                                        Save Organization Information
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </mat-tab>
                <mat-tab>
                    <ng-template mat-tab-label>
                        <mat-icon class="example-tab-icon">account_balance</mat-icon>
                        <span>Billing</span>
                    </ng-template>
                    <ng-template matTabContent>
                        <mat-tab-group class="mt-2">
                            <mat-tab>
                                <ng-template mat-tab-label>
                                    <mat-icon class="example-tab-icon">payments</mat-icon>
                                    <span>Subscriptions</span>
                                </ng-template>
                                <ng-template matTabContent>
                                    <app-my-account-billing></app-my-account-billing>
                                </ng-template>
                            </mat-tab>
                            <mat-tab>
                                <ng-template mat-tab-label>
                                    <mat-icon class="example-tab-icon">payments</mat-icon>
                                    <span>Payment Methods</span>
                                </ng-template>
                                <ng-template matTabContent>
                                    <my-account-payment-methods></my-account-payment-methods>
                                </ng-template>
                            </mat-tab>
                        </mat-tab-group>
                    </ng-template>
                </mat-tab>
                <mat-tab>
                    <ng-template mat-tab-label>
                        <mat-icon class="example-tab-icon">credit_card</mat-icon>
                        <span>Player Payment</span>
                    </ng-template>
                    <ng-template matTabContent>
                        <my-account-player-payment></my-account-player-payment>
                    </ng-template>
                </mat-tab>
            </mat-tab-group>
        </mat-card-content>
    </mat-card>
</div>
